import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Col, DropdownMenu, DropdownToggle, Navbar, UncontrolledDropdown } from 'reactstrap';
import CLLogo from '../../../assets/images/CLAS-Logo.svg';
import { useMsalDetails } from '../../../authentication-context/msalContext';
import { isAzureMfaEnabled } from '../../../config/env';
import { getCurrentUser, logout } from '../../routines/user-operations';
import { useSidebar } from '../layout/sidebarContext';

const Header = () => {
  const user = getCurrentUser();
  const { startLogout } = useMsalDetails();
  const { toggle, isOpen } = useSidebar();

  const handleLogout = async () => {
    logout();
    if (isAzureMfaEnabled?.toLowerCase() === 'true') {
      await startLogout();
    }
  };

  return (
    <div className="header">
      <button
        type="button"
        className="hamburger-btn"
        onClick={toggle}
        aria-label={isOpen ? 'Close navigation' : 'Open navigation'}
        aria-expanded={isOpen}
      >
        <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`} />
      </button>
      <Navbar className="custom-container row" expand="lg">
        <Col lg={6} md={6} xs={6} className="custom-navbrand">
          <Link className="navbar-brand" to="">
            <img src={CLLogo} alt="Cypress Lawn" className="cypress-logo" />
          </Link>
        </Col>
        <Col lg={6} md={6}>
          <ul className="Nav-ul-list mb-0">
            <li className="navbar-right-wrapper">
              <div className="user-section">
                <UncontrolledDropdown>
                  <DropdownToggle className="user-section-btn d-flex align-items-center justify-content-center">
                    <small className="user-image-wrapper">
                      <b className="d-flex align-items-center justify-content-center">
                        {_.get(user, 'name[0]', 'J')}
                      </b>
                    </small>
                    <span className="user-name">{_.get(user, 'name', 'Jane Tran')}</span>
                    <i className="fas fa-chevron-down ml-auto" />
                  </DropdownToggle>
                  <DropdownMenu className="user-section-dropdownlists" right>
                    <button
                      type="button"
                      className="user-section-dropdownlist user-logout"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </li>
          </ul>
        </Col>
      </Navbar>
    </div>
  );
};

export default Header;
